import React from 'react';
import { Row, Col, Form } from 'antd';
import { omit  } from 'lodash';
import { ReactComponent as Bin } from 'assets/icons/bin.svg';
import { FormField } from 'components';
import { carrierUsersFields } from './field';
import { percentageFormatter } from 'utils';

const CarrierUsers = ({
  update,
  removeUser,
  index,
  carrierUsers,
  disabled,
}) => {
  

  const handleChange = ({ key, type, event , index }) => {
    let newValue;

    if (type === 'text' || type === 'textarea' || type === 'radio') {
        newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString("en-US");
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals'
    ) {
      newValue = event;
    }
    
    update({key,newValue,index})

  };



  return (
    <div className="shareHolderRow">
      <Row gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }} key={index}>
        {carrierUsersFields(
                    !disabled && carrierUsers?.length > 1
                  , carrierUsers, index)?.map((field, i) => {
          return (
            <Col key={i} span={field.span} className="pt-1 pb-1">
              <Form.Item
                name={['carrierUsers', index, field.name]}
                validateFirst={true}
                rules={field.rules}
              >
                <FormField
                  value={carrierUsers[index] && carrierUsers[index][field.name]}
                  {...omit(field, ['span', 'rules'])}
                  filterOption={field.filterOption}
                  disabled={false}
                  key={index + '_' + field.name + '_' + i}
                  onChange={event =>
                    handleChange({
                      key: field.name,
                      event: event,
                      type: field.type,
                      index
                    })
                  }
                />
              </Form.Item>
            </Col>
          );
        })}

        {!disabled && index !== 0 && carrierUsers?.length > 1 && (
          <Col className=" delete-icon pt-1 pb-1">
            <Bin
              onClick={() => removeUser(index)}
            />
          </Col>
        )}
        <Col span={10}></Col>
      </Row>
    </div>
  );
};

export default CarrierUsers;
